import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const getZonasUrl = "api/v1/websalud/primeraars/catalogo/zonas";

const getProvinciasUrl = "api/v1/websalud/primeraars/catalogo/provincias";

const getDiagnosticosUrl = "api/v1/websalud/primeraars/catalogo/diagnosticos";

const getZonas = (request) =>
  InterceptToken(BaseApi.get, getZonasUrl, request).then(
    (response) => response.data
  );

const getProvincias = (request) =>
  InterceptToken(BaseApi.get, getProvinciasUrl, request).then(
    (response) => response.data
  );

const getDiagnosticos = (payload = {}) => {
  const { Pagina = 1, Tamanio = 10, Buscar } = payload;
  const params = {
    Pagina: Number(Pagina),
    Tamanio: Number(Tamanio),
  };
  if (Buscar != null && String(Buscar).trim() !== "") {
    params.Buscar = String(Buscar).trim();
  }
  return InterceptToken(BaseApi.get, getDiagnosticosUrl, params).then(
    (response) => response.data
  );
};

const exportedObject = {
  getZonas,
  getProvincias,
  getDiagnosticos,
};

export default exportedObject;
